import { FormControl, InputLabel } from '@mui/material';
import { type ReactNode, useId } from 'react';

import { FormHelperText } from '../../atoms/FormHelperText';
import { Select, type SelectProps } from '../../atoms/Select';

type Props<Value> = Omit<SelectProps<Value>, 'labelId' | 'label'> & {
  label?: ReactNode;
  helperText?: ReactNode;
};

export function SelectField<Value = unknown>(props: Props<Value>) {
  const {
    label,
    helperText,
    required,
    error,
    disabled,
    fullWidth,
    size,
    'aria-describedby': describedBy,
    ...selectProps
  } = props;
  const labelId = useId();
  const helperId = useId();
  const descriptionIds = [describedBy, helperText ? helperId : undefined].filter(Boolean).join(' ');

  return (
    <FormControl required={required} error={error} disabled={disabled} fullWidth={fullWidth} size={size}>
      {label ? <InputLabel id={labelId}>{label}</InputLabel> : null}
      <Select<Value>
        labelId={label ? labelId : undefined}
        label={label}
        aria-describedby={descriptionIds || undefined}
        {...selectProps}
      />
      {helperText ? <FormHelperText id={helperId}>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}

export type { Props as SelectFieldProps };
